import { render, staticRenderFns } from "./WarningBloc.vue?vue&type=template&id=8220f462"
import script from "./WarningBloc.vue?vue&type=script&lang=js"
export * from "./WarningBloc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports